import React from 'react';
function CloseProjectIcon({
  className = '',
  color = '#778CA2',
  width = 14,
  height = 14
}) {
  return <svg width={width} height={height} className={className} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.6758 8.17578V7H5.82422V8.17578H11.6758ZM11.6758 10.5V9.32422H9.32422V10.5H11.6758ZM8.17578 10.5V9.32422H2.32422V10.5H8.17578ZM2.32422 7V8.17578H4.67578V7H2.32422ZM11.6758 2.32422C11.9857 2.32422 12.25 2.44271 12.4688 2.67969C12.7057 2.91667 12.8242 3.1901 12.8242 3.5V10.5C12.8242 10.8099 12.7057 11.0833 12.4688 11.3203C12.25 11.5573 11.9857 11.6758 11.6758 11.6758H2.32422C2.01432 11.6758 1.74089 11.5573 1.50391 11.3203C1.28516 11.0833 1.17578 10.8099 1.17578 10.5V3.5C1.17578 3.1901 1.28516 2.91667 1.50391 2.67969C1.74089 2.44271 2.01432 2.32422 2.32422 2.32422H11.6758Z" fill={color} />
    </svg>;
}
export default CloseProjectIcon;